export default __webpack_public_path__ + "static/media/event-head.2b741199.png";